import { render } from "./OffcanvasPage.vue?vue&type=template&id=545af681&ts=true"
import script from "./OffcanvasPage.vue?vue&type=script&lang=ts"
export * from "./OffcanvasPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__